const HeroTitle = props => {
  return (
    <h1 className={`fw-bold ${props.className}`} style={{fontSize: '60px'}}>{props.children}</h1>
  );
}

export default HeroTitle;
